import { Component } from "react";
import './App.js';
import './App.css';

export default class App extends Component {
    render() {
        return (
            <canvas className="canvas" id="canvas"></canvas>
        )
    }
}